angular.module('jv.Candidate.ManageCollabTeam.Controller', [])
    .controller('jvcandidatemanagecollabteamcontroller', [
        '$scope', '$rootScope','jvCandidatesService', '$window', 'GAService',
        function($scope, $rootScope,jvCandidatesService, $window, GAService) {
            //set flag to false on load as its set to true on every routeChange
            $scope.flags.loading = false;

            //pagination cofigs
            $scope.currentPage = 0;
            $scope.pageSize = 10;
            
            var init = function() {
            	//settings up params for GET call
                var args = {
                    applicationId: $scope.applicationId
                };

                //Make call to get collab team
                jvCandidatesService.getCollabTeamUsers(args,function(response){
                    if(response && response.data.users && response.data.users.length){
                        $scope.collabTeamUsers = response.data.users;
                        if($scope.collabTeamUsers.length <= $scope.pageSize){
                            $scope.hideNext = true;
                        }
                        $scope.collabTeamUsersInView = $scope.collabTeamUsers.slice($scope.currentPage,$scope.pageSize);
                    }
                });
            }

            init();

            $rootScope.$on('application_details_updated', function() {
                if ($scope.stickyTab === 'feed') {
                    init();
                }
            });

            //pagination for  all collabTeamUsers widget
            $scope.paginateNext = function(pageNumber) {
                $scope.currentPage = pageNumber;
                $scope.hideNext = $scope.currentPage >= Math.floor($scope.collabTeamUsers.length/$scope.pageSize) ? true: false;
                var start = (pageNumber*$scope.pageSize);
                var loopEnd = (start+$scope.pageSize);
                $scope.collabTeamUsersInView = [];
                for(var i=start; i < loopEnd; i++){
                     if($scope.collabTeamUsers[i]){
                     	if ($scope.collabTeamUsersDeleted && $scope.collabTeamUsersDeleted.length > 0 && $scope.isUserMarkedToBeDeleted($scope.collabTeamUsers[i])) {
                     		continue;
                     	}
                        $scope.collabTeamUsersInView.push($scope.collabTeamUsers[i]);
                     }
                }
            };

            // checking if the user is marked as deleted
            $scope.isUserMarkedToBeDeleted = function(userObjectToBeChecked) {
            	var markedAsDeleted = false;
            	angular.forEach($scope.collabTeamUsersDeleted,function(userObject){
                    if(userObject === userObjectToBeChecked.EId){
                        markedAsDeleted = true;
                    }
                });
                return markedAsDeleted;
            };

            // marking users to be deleted
            $scope.delete = function(userObjectToBeDeleted) {
            	angular.forEach($scope.collabTeamUsersInView,function(userObject){
                    if(userObject.EId === userObjectToBeDeleted.EId){
                        markedAsDeleted = true;
                    }
                });

                for(var i = 0; i < $scope.collabTeamUsersInView.length; i++){
					if ($scope.collabTeamUsersInView[i].EId===userObjectToBeDeleted.EId) {
						$scope.collabTeamUsersInView.splice(i, 1);	
					} 
				}

            	// maintaining a list for the users to be deleted
            	$scope.collabTeamUsersDeleted.push(userObjectToBeDeleted.EId);
            };

            $scope.edit= function() {
	            $scope.collabTeamUsers.edited = true;
	            $scope.collabTeamUsers.showError= false;
	            $scope.collabTeamUsersDeleted=[];
        	};

        	$scope.cancel= function() {
	            $scope.collabTeamUsers.edited = false;
	            $scope.collabTeamUsersDeleted=[];
        	};

        	$scope.save= function() {
        		if ($scope.collabTeamUsersDeleted && $scope.collabTeamUsersDeleted.length > 0) {

        			$scope.flags.loading = true;

        			//settings up params for POST call
	                var args = {
	                    applicationId: $scope.applicationId,
	                    userIds: $scope.collabTeamUsersDeleted
	                };

        			jvCandidatesService.deleteCollabTeamUsers(args,function(response){
	                    if(response && response.status){
	                        if(response.status==200){
                        		$scope.showMsg('CHANGES_SAVED');
                        	}
                        	$scope.flags.loading = false;

                        	// reset the deleted array & reload the collab team
		        			$scope.collabTeamUsersDeleted= [];
		        			$scope.collabTeamUsers = [];
		        			$scope.collabTeamUsersInView = [];
		        			$scope.currentPage = 0;
		        			
		        			init();
	                    }
	                });

        		}
        	}

        }
]);